import React from "react";
import { Box, Text, VStack, IconButton, HStack, useClipboard } from "@chakra-ui/react";
import { EmailIcon, CopyIcon } from "@chakra-ui/icons";

const ContactUsBox = () => {
  const email = "blindfoldcapital@gmail.com";
  const { hasCopied, onCopy } = useClipboard(email);

  return (
    <Box
      p={4}
      bg="white"
      shadow="md"
      borderRadius="md"
      borderWidth="1px"
      maxW="400px"
      textAlign="center"
    >
      <VStack spacing={3}>
        <Text fontSize="lg" fontWeight="bold" color="blue.600">
          Contact Us
        </Text>

        <HStack spacing={2}>
          <EmailIcon color="blue.500" />
          <Text fontSize="sm" color="gray.700">
            {email}
          </Text>
          <IconButton
            size="xs"
            icon={<CopyIcon />}
            onClick={onCopy}
            aria-label="Copy Email"
            colorScheme="blue"
          />
        </HStack>

        {hasCopied && <Text fontSize="xs" color="green.500">Copied to clipboard!</Text>}
      </VStack>
    </Box>
  );
};

export default ContactUsBox;
